import { useParams } from "react-router-dom";

import { useWardDetails } from "../../../hooks/queries/admin/wards";
import {
  AdminBreadcrumb,
  ErrorMessage,
  PageContainer,
  PageHeader,
  PageIntro,
  PageTitle,
  WardDetailsPanel,
} from "../shared";

/**
 * Ward details route (EN-5151). Retool edited a ward in a modal with its
 * history stacked behind another one; the portal makes it a route so the
 * embedded audit trail can use the single global modal slot for its own row
 * drill-down.
 */
export function AdminWardDetails() {
  const { wardId } = useParams<{ wardId: string }>();
  const parsedWardId = Number(wardId);
  const isValidWardId = Number.isFinite(parsedWardId) && parsedWardId > 0;

  // Same cache entry the panel reads, so naming the crumb costs no request.
  const { ward } = useWardDetails(isValidWardId ? parsedWardId : undefined);

  const currentLabel =
    ward?.name || (isValidWardId ? `Ward #${parsedWardId}` : "Ward details");

  document.title = `${currentLabel} - Admin`;

  return (
    <PageContainer>
      <PageIntro>
        <AdminBreadcrumb
          items={[
            { label: "Wards", to: "/admin/wards" },
            { label: currentLabel },
          ]}
        />
        <PageHeader>
          <PageTitle>{currentLabel}</PageTitle>
        </PageHeader>
      </PageIntro>

      {isValidWardId ? (
        <WardDetailsPanel wardId={parsedWardId} />
      ) : (
        <ErrorMessage>That ward id isn&apos;t valid.</ErrorMessage>
      )}
    </PageContainer>
  );
}
